import { post , get , put} from '../http';
import { getStorage } from '../../utils/tools'

export async function queryOrgsApi(params){
    return post('/open_api/v1/orgs', params,true,50000,"ap2");
} 
